import { useState } from "react";
import { faqList } from "@/mocks/homeData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start">
        {/* left trust block */}
        <div className="lg:col-span-5">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wider text-secondary-800">
            <i className="ri-shield-check-line text-secondary-700"></i>
            围观守则
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[34px] md:leading-tight">
            先把规矩讲清楚，<br className="hidden md:block" />瓜才能吃得安心
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            17黑料希望这里是一块热闹但有分寸的地儿。常见问题都在下面，回答清楚，别带着疑问进场。
          </p>

          <div className="mt-6 space-y-3">
            <div className="flex items-start gap-3 rounded-xl bg-background-100 p-4">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-discuss-line"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">留证据、讲逻辑</p>
                <p className="mt-1 text-[13px] text-foreground-600">讨论对事不对人，摆证据比喊口号更有分量。</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-xl bg-background-100 p-4">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                <i className="ri-flag-2-line"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">有疑问可求证</p>
                <p className="mt-1 text-[13px] text-foreground-600">觉得内容存疑？标注“求证”并补充线索，让大家一起核。</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-xl bg-background-100 p-4">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-hand-heart-line"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">拒绝人身攻击</p>
                <p className="mt-1 text-[13px] text-foreground-600">造谣与辱骂会被清理，茶馆干净，讨论才长久。</p>
              </div>
            </div>
          </div>
        </div>

        {/* right FAQ accordion */}
        <div className="lg:col-span-7">
          <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50 px-5 md:px-7">
            {faqList.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="py-5 md:py-6">
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="text-sm font-semibold text-foreground-950 md:text-[15px]">{f.q}</span>
                    </span>
                    <i className={`ri-add-line shrink-0 text-lg text-foreground-500 transition-transform ${isOpen ? "rotate-45" : ""}`}></i>
                  </button>
                  {isOpen && (
                    <p className="mt-3 pl-10 text-[13px] leading-relaxed text-foreground-600 md:text-sm">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}